
<div :data-component-name="$options.name" class="img90tit10 graphik_bold">
  <a
    :href="content.internalUrl"
    :data-tag="`${jel_getNomRouteCourante()} - ${content.titre.replace(/&nbsp;/g, ' ')} - ${
      content.dataTag
    }`"
    class="offre-speciale"
  >
    <div class="h-100">
      <img v-lazy="jel_getFichierSrc(content.image)" class="w-100 image" :alt="content.titre" />
      <div class="img90tit10_text_content">
        <p v-if="content.surTitre" v-html="content.surTitre"></p>
        <div class="img90tit10_titre graphik_bold" v-html="content.titre"></div>
        <p v-if="content.sousTitre" v-html="content.sousTitre"></p>
      </div>
    </div>
    <div v-html="content.texte"></div>
  </a>
</div>
